export default __webpack_public_path__ + "b65fd23f6d17f5fb94d6e3624fae77c2.svg";